@if (currentUser?.biometric_required) {
  <div class="monster__banner monster__banner--warning">
    <i class="monster__banner-icon fa-regular fa-triangle-exclamation"></i>

    <div class="monster__banner-body">
      <div class="monster__banner-text">
        <h3 class="monster__banner-title">
          {{ 'documents.identityConfirmationTitle' | translate }}
        </h3>
        <p class="monster__banner-description">
          {{ 'documents.identityConfirmationDescription' | translate }}
        </p>
        <!--        <span class="monster__badge badge-XS badge-error">Label</span>-->
      </div>

      <div class="monster__banner-actions">
        <button type="button" class="btn-M btn-filled" (click)="validateUserCreateDocument()">
          {{ 'button.identityConfirmationButton' | translate }}
        </button>
      </div>
    </div>

    <!--    <button type="button" class="monster__banner-close btn-S btn-text btn-text-cancel icon-only">-->
    <!--      <i class="fa-regular fa-xmark"></i>-->
    <!--    </button>-->
  </div>
}
